import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

import FancySwitch from '@/components/FancySwitch';
import useToasts from '@/hooks/useToasts';
import { api } from '@/utils/api';

const StyledFancySwitch = styled(FancySwitch)`
  background: ${({ theme }) => theme.colors.white};
  height: 32px;
  border-color: ${({ theme }) => theme.colors.grayscale};
  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  enabled?: boolean;
}

const ProfanityCheckToggle: FC<Props> = ({ enabled }) => {
  const toasts = useToasts();

  const [state, setState] = useState(!!enabled);
  const [isLoading, setIsLoading] = useState(true);

  const toggle = async () => {
    setIsLoading(true);

    const toastId = toasts.create('loading', 'Saving...');

    try {
      const newState = !state;

      setState(newState);

      await api.post('/v1/editorial/comment-checks/profanity', {
        enabled: newState,
      });

      toasts.success(toastId, 'Saved');
    } catch (_) {
      toasts.error(toastId, 'Error!');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (typeof enabled !== 'undefined') {
      setState(enabled);
      setIsLoading(false);
    }
  }, [enabled]);

  return (
    <StyledFancySwitch
      text="Profanity check"
      onLabel="On"
      offLabel="Off"
      disabled={isLoading}
      isActive={state}
      onClick={toggle}
    />
  );
};

export default ProfanityCheckToggle;
